// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
    padding: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f4f4f9;
    max-height: 100vh; /* Set a max height for the container */
    overflow-y: auto; /* Allow vertical scrolling */
  }
  
  .back-button {
    display: flex !important;
    margin-bottom: 20px;
    background-color: #007bff;
    color: white;
  }
  
  .dashboard-content {
    width: 80%;
    background-color: white;
    padding: 30px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    max-height: 80vh; /* Set a max height for the content */
    overflow-y: auto; /* Allow scrolling within the content */
  }
  
  .dashboard-header {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .dashboard-name {
    font-size: 2rem;
    font-weight: bold;
    margin-top: -65px !important;
  }
  
  .dashboard-role {
    font-size: 1.2rem;
    color: gray;
  }
  
  .dashboard-status-login {
    display: flex;
    justify-content: space-around;
    margin-bottom: 20px;
  }
  
  .dashboard-status,
  .dashboard-last-login {
    font-size: 1.1rem;
  }
  
  .dashboard-phases {
    background-color: #f9f9f9;
    padding: 20px;
    border-radius: 8px;
  }
  
  .phase-card {
    background-color: white;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    text-align: center;
  }
  
  .phase-item {
    font-size: 1rem;
    font-weight: bold;
  }
  
  .graph-title {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .graph-card {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  }
  
  .graph-heading {
    margin-bottom: 10px;
  }
  
  .chart-container {
    height: 150px; /* Set a fixed height for the graphs */
  }
  
  .no-data {
    font-size: 1.2rem;
    color: #666;
  }
  `, "",{"version":3,"sources":["webpack://./src/screens/Projects/Analysis/UserDetail/UserDetail.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,yBAAyB;IACzB,iBAAiB,EAAE,uCAAuC;IAC1D,gBAAgB,EAAE,6BAA6B;EACjD;;EAEA;IACE,wBAAwB;IACxB,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,wCAAwC;IACxC,gBAAgB,EAAE,qCAAqC;IACvD,gBAAgB,EAAE,uCAAuC;EAC3D;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,4BAA4B;EAC9B;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,6BAA6B;IAC7B,mBAAmB;EACrB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,wCAAwC;EAC1C;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa,EAAE,sCAAsC;EACvD;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb","sourcesContent":[".dashboard-container {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    background-color: #f4f4f9;\n    max-height: 100vh; /* Set a max height for the container */\n    overflow-y: auto; /* Allow vertical scrolling */\n  }\n  \n  .back-button {\n    display: flex !important;\n    margin-bottom: 20px;\n    background-color: #007bff;\n    color: white;\n  }\n  \n  .dashboard-content {\n    width: 80%;\n    background-color: white;\n    padding: 30px;\n    border-radius: 10px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    max-height: 80vh; /* Set a max height for the content */\n    overflow-y: auto; /* Allow scrolling within the content */\n  }\n  \n  .dashboard-header {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .dashboard-name {\n    font-size: 2rem;\n    font-weight: bold;\n    margin-top: -65px !important;\n  }\n  \n  .dashboard-role {\n    font-size: 1.2rem;\n    color: gray;\n  }\n  \n  .dashboard-status-login {\n    display: flex;\n    justify-content: space-around;\n    margin-bottom: 20px;\n  }\n  \n  .dashboard-status,\n  .dashboard-last-login {\n    font-size: 1.1rem;\n  }\n  \n  .dashboard-phases {\n    background-color: #f9f9f9;\n    padding: 20px;\n    border-radius: 8px;\n  }\n  \n  .phase-card {\n    background-color: white;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    text-align: center;\n  }\n  \n  .phase-item {\n    font-size: 1rem;\n    font-weight: bold;\n  }\n  \n  .graph-title {\n    text-align: center;\n    margin-bottom: 20px;\n  }\n  \n  .graph-card {\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .graph-heading {\n    margin-bottom: 10px;\n  }\n  \n  .chart-container {\n    height: 150px; /* Set a fixed height for the graphs */\n  }\n  \n  .no-data {\n    font-size: 1.2rem;\n    color: #666;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
